/**
 * Created by jv on 01/03/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class User
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};
    options.meta = utils.isNotNull(options.meta) ? options.meta : {};

    this.userKey = options["user-key"];
    this.profileKey = options["profile-key"];

    this.displayName = options["display-name"];

    this.firstname = options.meta.firstname;
    this.lastname = options.meta.lastname;
    this.email = options.email;
    this.newsletter = options.meta.newsletter === "1";

    this._locale = options.locale;
    this.type = options.type;

    this.role = options.role;

    this.enabled = options.enabled;
    this.validated = options.validated;
    this.authenticated = options.authenticated;
  }

  get locale()
  {
    return utils.isNullOrEmpty(this._locale) ? null : this._locale.split("_")[0];
  }

  get country()
  {
    return utils.isNullOrEmpty(this._locale) ? null : this._locale.split("_")[1];
  }

  serialize()
  {
    return utils.stringifyJSON({
      "user-key": this.userKey,
      "profile-key": this.profileKey,
      "type": this.type,
      "email": this.email,
      "locale": this._locale,
      "display-name": this.displayName,
      "role": this.role,
      "meta": {
        "firstname": this.firstname,
        "lastname": this.lastname
      },
      "enabled": this.enabled,
      "authenticated": this.authenticated,
      "incomplete": this.incomplete,
      "validated": this.validated
    });
  }

  get isAdmin()
  {
    return this.role === "admin";
  }
}



// WEBPACK FOOTER //
// ./app/js/models/user.js